module.exports = __webpack_public_path__ + "static/media/socket_clevis.aaf4eb2b.webp";